import { render, staticRenderFns } from "./TakedaLogo.vue?vue&type=template&id=1447120e&"
var script = {}
import style0 from "./TakedaLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports